<app-common-bulk-select-survey-participants-dialog
    #selectParticipants
    (selectedParticipantsUpdated)="(updateSelectedParticipants)"
    headerText="surveys.store.surveyParticipantsForm.headerText"
    label="surveys.store.surveyParticipantsForm.assignLabel"
></app-common-bulk-select-survey-participants-dialog>

<form #form="ngForm">
    <app-segment-header title="" subtitle="surveys.store.surveyParticipantsForm.subtitle"> </app-segment-header>

    <div *ngIf="employees.length > 0">
        <div class="flex align-center space-between middle margin-y-3">
            <app-search
                #searchBar
                placeholder="surveys.store.surveyParticipantsForm.searchByParticipant"
                (onSearch)="onSearch($event)"
            ></app-search>
        </div>
        <app-simple-table
            [attr.data-cy]="'survey-selected-participants-table'"
            [columns]="columns"
            [rows]="rows"
            [sticky]="true"
            [fixedHeight]="true"
        ></app-simple-table>
    </div>

    <div [class.loading]="isLoading">
        <ui-button (click)="openParticipantSelect()" label="Select Participants" type="primary">{{
            employees?.length < 1
                ? ('surveys.store.surveyParticipantsForm.selectParticipants' | translate)
                : ('surveys.store.surveyParticipantsForm.selectOrRemoveParticipants' | translate)
        }}</ui-button>
    </div>
</form>
